import { Box, MenuItem, Select, Typography } from "@mui/material";
import React, { useState } from "react";

const CustomDropDown = (props) => {
  const {
    value,
    onChange,
    NoData,
    menuList,
    placeholder,
    title,
    sx = {},
    titlesx = {},
  } = props;
  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Typography
          sx={{
            fontWeight: "400",
            textAlign: "left",
            fontSize: "14px",
            color: "#FFFFFF60",
            ...titlesx,
          }}
        >
          {title}
        </Typography>
        <Select
          sx={{
            width: "100%",
            height: "50px",
            border: "0.5px solid #EAE8FF14",
            background: "#fff",
            borderRadius: "10px",
            color:'#000',
            mt:"5px",
            "&:focus": {
              outline: "none",
              boxShadow: "none",
            },
            "&:hover": {
              outline: "none",
            },
            ".MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            ...sx,
          }}
          value={value}
          onChange={onChange}
          displayEmpty
        >
          {menuList ? (
            menuList.map((elem, index) => (
              <MenuItem key={index} value={elem.id}>
                {elem.name || elem.category_name}
              </MenuItem>
            ))
          ) : (
            <Typography>{NoData}</Typography>
          )}
        </Select>
      </Box>
    </>
  );
};

export default CustomDropDown;
